//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showSpeechBubble1: true,
            result: this.$game.getMediaResult(1),
            clickAreas: [
                {
                    show: true,
                    showBubbleDialog: false,
                    shown: false,
                    x: 970,
                    y: 140,
                    title: this.$lang.get('w1d1.game6.light'),
                    image: '/images/game/w1d1/game6/game6_circle_light.png',
                    shownImage: '/images/game/icon_checked.png',
                    bubbleImage: {
                        x: 620,
                        y: 350,
                        path: '/images/game/w1d1/game6/robi_and_sun.png'
                    },
                    bubbles: [{
                        x: 540,
                        y: 500,
                        label: this.$lang.get('w1d1.game6.lightcheck', {br: '\n'})
                    }]
                },
                {
                    show: false,
                    showBubbleDialog: false,
                    shown: false,
                    x: 160,
                    y: 200,
                    title: this.$lang.get('w1d1.game6.air'),
                    image: '/images/game/w1d1/game6/game6_circle_air.png',
                    shownImage: '/images/game/icon_checked.png',
                    bubbleImage: {
                        x: 620,
                        y: 460,
                        path: '/images/game/w1d1/game6/robi_and_air.png'
                    },
                    bubbles: [{
                        x: 540,
                        y: 500,
                        label: this.$lang.get('w1d1.game6.aircheck', {br: '\n'})
                    }]
                },
                {
                    show: false,
                    showBubbleDialog: false,
                    shown: false,
                    x: 180,
                    y: 425,
                    title: this.$lang.get('w1d1.game6.water'),
                    image: '/images/game/w1d1/game6/game6_circle_water.png',
                    shownImage: '/images/game/icon_checked.png',
                    bubbleImage: {
                        x: 620,
                        y: 530,
                        path: '/images/game/w1d1/game6/robi_and_water.png'
                    },
                    bubbles: [{
                        x: 540,
                        y: 500,
                        label: this.$lang.get('w1d1.game6.watercheck', {br: '\n'})
                    }]
                },
                {
                    show: false,
                    showBubbleDialog: false,
                    shown: false,
                    x: 280,
                    y: 635,
                    title: this.$lang.get('w1d1.game6.soil'),
                    image: '/images/game/w1d1/game6/game6_circle_soil.png',
                    shownImage: `/images/game/w1d1/game6/error_${this.$lang.locale}.png`,
                    bubbleImage: {
                        x: 650,
                        y: 450,
                        path: '/images/game/w1d1/game6/robi_error.png'
                    },
                    bubbles: [{
                        x: 580,
                        y: 400,
                        label: this.$lang.get('w1d1.game6.soilcheck', {br: '\n'})
                    },{
                        x: 920,
                        y: 450,
                        label: this.$lang.get('w1d1.game6.robi', {br: '\n'})
                    }]
                }
            ]
        };
    },

    methods: {
        show () {
            this.showSpeechBubble1 = false;

            this.clickAreas.forEach(area => area.showBubbleDialog = false);

            let currentClickArea = this.clickAreas.find(area => area.show && !area.shown);
            if (currentClickArea !== undefined) {
                currentClickArea.shown = true;
                currentClickArea.showBubbleDialog = true;
            }

            let nextClickArea = this.clickAreas.find(area => !area.shown);
            if (nextClickArea !== undefined) {
                nextClickArea.show = true;
            } else {
                this.showNext = true;
            }
        }
    }
};
